import { FC, ReactElement } from 'react'
import { useNotifications, SimpleModal } from '@sequencehq/core-components'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useNavigate } from 'react-router-dom'
import { automationsPaths } from 'Automations/router'

export const ModalCancelManualTask: FC<{
  trigger: ReactElement
  taskId: string
}> = ({ trigger, taskId }) => {
  const { displayNotification } = useNotifications()
  const navigate = useNavigate()

  return (
    <SimpleModal
      trigger={trigger}
      variant="dialog"
      title="Cancel task"
      submitButtonText="Cancel task"
      submittingButtonText="Cancelling..."
      data-testid="watchtower.manualTask.cancel"
      isDestructive
      onSubmit={async () => {
        const { error } = await dashboardv99990101Client.postCancelManualTask({
          id: taskId
        })

        if (error) {
          displayNotification('Failed to cancel task', {
            type: 'error'
          })
          return false
        }

        displayNotification('Task cancelled', { type: 'success' })
        navigate(automationsPaths.manualTasksInbox())
        return true
      }}
    >
      Are you sure you want to cancel this task?
    </SimpleModal>
  )
}
